import React from 'react';
import { Link } from 'react-router-dom';

export const Logo = () => (
  <Link to="/" className="flex items-center gap-3">
    <img src="/logo-icon.png" alt="" className="h-11" />
    <div className="hidden sm:block">
      <div className="text-white font-bold text-lg leading-tight">
        Echoes of Ibadan
      </div>
      <div className="text-[#D4AF37] text-xs tracking-wider uppercase">
        Scholarly Archive
      </div>
    </div>
  </Link>
);
